import QRCode from "qrcode";

const qrOptions = {
  margin: 2,
  color: {
    dark: "#121815",
    light: "#ffffff",
  },
  errorCorrectionLevel: "M" as const,
};

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export async function downloadQrArtifact(
  value: string,
  format: "svg" | "png",
  filename: string,
) {
  if (format === "svg") {
    const svg = await QRCode.toString(value, {
      ...qrOptions,
      type: "svg",
      width: 1024,
    });
    downloadBlob(
      new Blob([svg], { type: "image/svg+xml;charset=utf-8" }),
      `${filename}.svg`,
    );
    return;
  }

  const dataUrl = await QRCode.toDataURL(value, {
    ...qrOptions,
    width: 1024,
    type: "image/png",
  });
  const response = await fetch(dataUrl);
  downloadBlob(await response.blob(), `${filename}.png`);
}
